module.exports = __webpack_public_path__ + "static/media/spinner_grey.ecf268e4.svg";